var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComparisonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 6,
    viewBox: "0 0 14 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 2.45172L10.6754 0.126716C10.4088 -0.139951 9.95877 0.0433818 9.95877 0.418382L9.95877 1.91005L0.833471 1.91C0.375137 1.91 0.000137227 2.285 0.000137242 2.74333C0.000137256 3.20166 0.375137 3.57666 0.833471 3.57666L9.95877 3.57672L9.95877 5.06838C9.95877 5.44338 10.4088 5.62672 10.6671 5.36005L12.9921 3.03505C13.1588 2.87672 13.1588 2.61005 13.0004 2.45172Z",
    fill: "#BBC2CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComparisonArrow);
export default __webpack_public_path__ + "static/media/icon-comparison-arrow.97442b78f162fc27bda48ddca83773fb.svg";
export { ForwardRef as ReactComponent };